import { CloseIcon } from '@chakra-ui/icons';
import { Button } from '@chakra-ui/react';
import { FC } from 'react';

type Props = {
  onClick: () => void;
};

export const ClearButton: FC<Props> = ({ onClick }) => (
  <Button size="xs" colorScheme="gray" variant="ghost" onClick={onClick}>
    <CloseIcon />
  </Button>
);
